export const KEY_GET_SUBSCRIPTION = 'get.subscription.call';
export const KEY_GET_BILLING_LINK = 'get.billing.link.call';
